import styled from '@emotion/styled';
import { theme } from 'configs/styled';

export const StyledLabel = styled('div')`
  span {
    color: ${props => props.color};
  }
  .normal {
    font-size: ${theme.fontSize.xs};
  }
  .large {
    font-size: ${theme.fontSize.md};
  }
  .small {
    font-size: ${theme.fontSize.xxxs};
  }
`;
